import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.scss'
import { IntersectionObserver } from 'vue-intersection-observer'
import '@fortawesome/fontawesome-free/css/all.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.directive('intersection-observer', IntersectionObserver)
app.mount('#app')
